module.exports = __webpack_public_path__ + "img/cli_11.5cb7f5fc.png";